export const PRESET_CRITERIA_ITEM = {
  conformed: ['Conformed', 'success'],
  conform: ['Conformed', 'success'],
  not_conform: ['Not Conform', 'error']
};
